// Browser-first pronunciation coordinator. Tries window.speechSynthesis for
// the requested language; on miss, falls back to the server /pronunciations
// endpoint and plays the returned audio_url via an <Audio> element.

function findVoice(lang) {
  if (!("speechSynthesis" in window)) return null;
  const voices = window.speechSynthesis.getVoices() || [];
  if (!voices.length) return null;
  const target = lang.toLowerCase();

  const matches = voices.filter(v => {
    const vl = (v.lang || "").toLowerCase();
    return vl === target || vl.startsWith(target + "-");
  });
  if (!matches.length) return null;

  const score = (v) => {
    const n = (v.name || "").toLowerCase();
    if (n.includes("premium")) return 4;
    if (n.includes("enhanced")) return 3;
    if (n.includes("neural") || n.includes("natural")) return 3;
    if (n.includes("compact")) return 0;
    return 1;
  };

  return matches.slice().sort((a, b) => score(b) - score(a))[0];
}

function speakWithBrowser(text, voice) {
  return new Promise((resolve, reject) => {
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.voice = voice;
    utterance.lang = voice.lang;
    utterance.onend = () => resolve();
    utterance.onerror = (e) => reject(e);
    window.speechSynthesis.speak(utterance);
  });
}

async function speakWithServer(text, lang) {
  const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
  const response = await fetch("/pronunciations", {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrf || ""
    },
    body: JSON.stringify({ text, lang })
  });
  if (!response.ok) throw new Error(`pronunciation ${response.status}`);
  const { audio_url: audioUrl } = await response.json();
  if (!audioUrl) throw new Error("no audio_url in response");

  return new Promise((resolve, reject) => {
    const audio = new Audio(audioUrl);
    audio.onended = () => resolve();
    audio.onerror = (e) => reject(e);
    audio.play().catch(reject);
  });
}

export async function pronounce({ text, lang }) {
  const voice = findVoice(lang);
  if (voice) {
    return speakWithBrowser(text, voice);
  }
  return speakWithServer(text, lang);
}
